import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PolicyZipCode = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 599, height: 458, fill: 'none', cursor: 'pointer', ...sx }}
    data-testid="ZipCodeIcon"
    width="599"
    height="458"
    fill="none"
    viewBox="0 0 599 458"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.0474 99.401C64.9777 55.171 116.838 31.5028 169.875 14.4596C220.842 -1.91847 274.882 -3.10317 330.25 4.53876C393.042 13.2052 460.895 18.7823 509.02 61.2681C559.26 105.622 579.635 171.136 589.613 233.513C599.732 296.771 610.034 371.603 565.573 414.807C521.5 457.635 441.715 431.548 377.324 439.806C331.403 445.695 289.749 462.513 242.741 456.208C190.117 449.15 136.453 436.224 94.9255 401.931C49.4765 364.399 15.0437 313.876 4.23061 259.244C-6.92347 202.889 4.1922 144.998 35.0474 99.401Z"
      fill="#F7F8FC"
    />
    <path
      d="M114.04 113.578C114.04 100.442 124.689 89.7932 137.825 89.7932H494.603C507.739 89.7932 518.388 100.442 518.388 113.578V351.43H114.04V113.578Z"
      fill="white"
    />
    <mask
      id="mask0_27088_67938"
      mask-type="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="124"
      y="93"
      width="384"
      height="259"
    >
      <path
        d="M124.947 103.882C124.947 98.3593 129.424 93.8821 134.947 93.8821H497.482C503.005 93.8821 507.482 98.3593 507.482 103.882V341.43C507.482 346.953 503.005 351.43 497.482 351.43H134.947C129.424 351.43 124.947 346.953 124.947 341.43V103.882Z"
        fill="#E3E5EE"
      />
    </mask>
    <g mask="url(#mask0_27088_67938)">
      <path
        d="M124.947 103.882C124.947 98.3593 129.424 93.8821 134.947 93.8821H497.482C503.004 93.8821 507.482 98.3593 507.482 103.882V341.43C507.482 346.953 503.004 351.43 497.482 351.43H134.947C129.424 351.43 124.947 346.953 124.947 341.43V103.882Z"
        fill="#E3E5EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M365.282 174.698C328.122 187.232 298.964 214.016 270.414 247.714C245.127 277.561 212.478 287.315 182.596 287.493C157.645 287.642 134.285 281.155 117.718 273.94C112.924 271.852 111.151 266.107 113.584 261.478C116.018 256.849 121.735 255.089 126.552 257.125C140.953 263.212 161.16 268.683 182.483 268.556C208.198 268.403 235.045 260.166 255.965 235.473C285.174 200.996 317.089 170.968 359.229 156.754C399.729 143.093 448.228 144.493 510.661 167.833C515.56 169.665 517.939 175.189 516.003 180.047C514.067 184.905 508.547 187.255 503.647 185.429C444.245 163.286 400.465 162.83 365.282 174.698Z"
        fill="#B6D6F7"
      />
      <path
        d="M437.687 273.38C392.681 277.043 375.196 315.184 370.621 340.985C369.621 346.622 374.197 351.43 379.922 351.43H497.481C503.004 351.43 507.481 346.953 507.481 341.43V320.115C507.481 308.551 454.931 271.723 443.423 272.863C441.561 273.048 439.649 273.22 437.687 273.38Z"
        fill="#9AD49A"
      />
      <path
        d="M196.007 253.896C180.957 257.13 141.048 240.041 135.362 233.072C124.044 219.199 181.871 145.013 207.324 145.013C222.792 145.013 248.934 192.883 248.039 200.878C246.567 214.037 207.324 251.464 196.007 253.896Z"
        fill="#9AD49A"
      />
      <path
        d="M507.481 116.091C507.481 120.61 504.428 124.617 500.008 125.554C460.967 133.829 441.303 119.228 433.219 105.079C430.117 99.6482 434.768 93.8821 441.023 93.8821H497.481C503.004 93.8821 507.481 98.3593 507.481 103.882V116.091Z"
        fill="#9AD49A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M354.423 280.462C355.355 276.99 358.079 274.285 361.558 273.377L512.617 233.971C515.147 233.311 516.663 230.724 516.003 228.194C515.343 225.664 512.757 224.148 510.227 224.808L353.839 265.605C350.361 266.513 347.637 269.218 346.705 272.69L325.205 352.828C324.527 355.353 326.025 357.95 328.551 358.627C331.076 359.305 333.673 357.807 334.35 355.281L354.423 280.462Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M267.327 280.239C268.954 278.192 271.932 277.851 273.979 279.477L335.315 328.202C337.363 329.828 337.704 332.807 336.077 334.854C334.451 336.901 331.473 337.243 329.426 335.616L268.089 286.891C266.042 285.265 265.701 282.287 267.327 280.239Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M305.879 234.091C307.505 232.044 310.483 231.703 312.531 233.329L353.306 265.721C355.353 267.347 355.695 270.325 354.068 272.373C352.442 274.42 349.464 274.761 347.416 273.135L306.641 240.743C304.594 239.117 304.253 236.139 305.879 234.091Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.446 346.162C171.968 350.198 178.045 350.742 182.228 347.396L267.098 279.5C269.14 277.866 272.119 278.198 273.752 280.239C275.386 282.281 275.055 285.26 273.013 286.894L181.058 360.457C176.875 363.804 170.798 363.26 167.277 359.223L116.522 301.055C114.803 299.085 115.006 296.094 116.976 294.375C118.946 292.656 121.937 292.859 123.656 294.83L168.446 346.162Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.737 120.615C218.001 118.411 223.229 119.547 226.194 123.322L309.891 229.9C311.506 231.956 311.148 234.933 309.091 236.547C307.035 238.162 304.059 237.805 302.444 235.748L223.584 135.33C220.62 131.555 215.391 130.419 211.128 132.623L93.1573 193.602C90.8345 194.803 87.9782 193.893 86.7776 191.571C85.577 189.248 86.4866 186.392 88.8093 185.191L213.737 120.615Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.022 282.488C268.978 280.857 268.643 277.878 270.274 275.835L300.51 237.938C302.141 235.894 305.12 235.559 307.164 237.19C309.208 238.821 309.542 241.8 307.912 243.843L277.675 281.74C276.045 283.784 273.066 284.119 271.022 282.488Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M400.677 95.3051C400.372 92.7082 402.231 90.3561 404.828 90.0517C407.425 89.7472 409.777 91.6056 410.081 94.2025L419.178 171.793C419.692 176.175 423.015 179.702 427.358 180.474L516.65 196.361C519.225 196.819 520.94 199.277 520.482 201.851C520.024 204.425 517.566 206.141 514.992 205.683L418.773 188.564C414.43 187.792 411.107 184.265 410.593 179.883L400.677 95.3051Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M417.036 182.575C418.256 184.888 417.369 187.752 415.056 188.971L317.415 240.455C315.102 241.674 312.239 240.788 311.019 238.475C309.8 236.162 310.686 233.299 312.999 232.079L410.64 180.596C412.953 179.376 415.816 180.263 417.036 182.575Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M422.176 252.61C419.881 253.864 417.005 253.021 415.751 250.727L390.093 203.778C388.839 201.484 389.683 198.607 391.977 197.353C394.272 196.099 397.148 196.943 398.402 199.237L424.06 246.186C425.314 248.48 424.47 251.357 422.176 252.61Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.831 131.816C121.707 129.352 124.414 128.064 126.877 128.94L166.787 143.118C169.251 143.993 170.539 146.7 169.663 149.164C168.788 151.628 166.081 152.916 163.617 152.04L123.708 137.862C121.244 136.987 119.956 134.28 120.831 131.816Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M400.972 81.0559C401.549 83.6062 399.949 86.141 397.398 86.7174L227.53 125.11C224.98 125.686 222.445 124.086 221.869 121.535C221.292 118.985 222.892 116.45 225.443 115.874L395.311 77.4817C397.861 76.9053 400.396 78.5055 400.972 81.0559Z"
        fill="white"
      />
      <path
        d="M148.38 94.0607C139.574 94.0607 136.047 103.694 143.99 107.499C158.925 114.655 179.452 118.258 202.391 108.71C211.092 105.088 207.63 94.0607 198.205 94.0607H148.38Z"
        fill="#B6D6F7"
      />
      <path
        d="M167.02 296.104L150.039 306.644C149.547 306.95 149.442 307.622 149.819 308.063L174.914 337.444C175.22 337.801 175.741 337.881 176.139 337.63L191.899 327.707C192.377 327.406 192.487 326.757 192.136 326.316L168.26 296.319C167.961 295.943 167.428 295.851 167.02 296.104Z"
        fill="#CFD2E0"
      />
      <path
        d="M262.498 145.582C261.895 144.727 262.099 143.545 262.954 142.943L283.226 128.649C284.081 128.046 285.263 128.25 285.865 129.105L304.787 155.941C305.39 156.796 305.186 157.978 304.331 158.58L284.059 172.874C283.204 173.477 282.022 173.273 281.42 172.418L262.498 145.582Z"
        fill="#CFD2E0"
      />
      <path
        d="M303.029 134.044C302.426 133.189 302.631 132.008 303.485 131.405L323.758 117.111C324.613 116.508 325.794 116.713 326.397 117.567L345.319 144.404C345.922 145.258 345.717 146.44 344.863 147.043L324.59 161.337C323.735 161.939 322.554 161.735 321.951 160.88L303.029 134.044Z"
        fill="#CFD2E0"
      />
      <path
        d="M344.014 120.78C343.411 119.925 343.616 118.744 344.47 118.141L364.743 103.847C365.598 103.244 366.779 103.449 367.382 104.304L386.304 131.14C386.907 131.995 386.702 133.176 385.847 133.779L365.575 148.073C364.72 148.675 363.539 148.471 362.936 147.616L344.014 120.78Z"
        fill="#CFD2E0"
      />
      <path
        d="M273.605 305.507C269.261 304.092 233.831 331.041 231.469 332.73C230.723 333.263 229.55 335.317 228.294 337.878C225.193 344.204 230.091 351.334 237.137 351.334L305.325 351.334C309.585 351.334 311.876 346.355 309.072 343.148C297.796 330.248 276.76 306.535 273.605 305.507Z"
        fill="#CFD2E0"
      />
      <path
        d="M355.092 256.361L339.53 242.096C339.028 241.635 339.162 240.81 339.786 240.533L354.721 233.895C355.167 233.697 355.692 233.871 355.931 234.297L365.845 251.97C366.133 252.484 365.887 253.134 365.33 253.327L356.043 256.558C355.714 256.672 355.349 256.597 355.092 256.361Z"
        fill="#CFD2E0"
      />
      <path
        d="M387.286 218.092L364.906 227.044C364.421 227.238 364.185 227.789 364.379 228.275L367.565 236.239C367.745 236.69 368.238 236.931 368.705 236.797L392.525 229.949C393.082 229.789 393.366 229.17 393.124 228.644L388.498 218.576C388.287 218.118 387.754 217.905 387.286 218.092Z"
        fill="#CFD2E0"
      />
      <path
        d="M392.651 231.983L370.272 240.935C369.786 241.129 369.55 241.68 369.744 242.166L372.93 250.13C373.111 250.581 373.604 250.822 374.071 250.688L397.89 243.84C398.447 243.68 398.731 243.061 398.489 242.535L393.864 232.467C393.653 232.009 393.12 231.796 392.651 231.983Z"
        fill="#CFD2E0"
      />
      <path
        d="M427.264 232.008L414.414 207.478C414.057 206.795 414.149 205.964 414.646 205.376L420.093 198.938C420.578 198.366 421.355 198.133 422.075 198.345L481.756 215.965C483.601 216.51 483.552 219.141 481.688 219.617L429.41 232.964C428.559 233.181 427.671 232.786 427.264 232.008Z"
        fill="#CFD2E0"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M494.603 107.632H137.825C134.541 107.632 131.879 110.294 131.879 113.578V333.592H500.549V113.578C500.549 110.294 497.887 107.632 494.603 107.632ZM137.825 89.7932C124.689 89.7932 114.04 100.442 114.04 113.578V351.43H518.388V113.578C518.388 100.442 507.739 89.7932 494.603 89.7932H137.825Z"
      fill="#373B49"
    />
    <path
      opacity="0.02"
      d="M429.193 89.7932L179.449 339.538H518.388V113.578C518.388 100.442 507.739 89.7932 494.603 89.7932H429.193Z"
      fill="#0B1421"
    />
    <path
      d="M268.644 351.43H90.2545C83.6864 351.43 78.3619 356.755 78.3619 363.323C78.3619 369.891 83.6864 375.215 90.2545 375.215H542.173C548.742 375.215 554.066 369.891 554.066 363.323C554.066 356.755 548.742 351.43 542.173 351.43H363.784C363.784 357.998 358.46 363.323 351.892 363.323H280.536C273.968 363.323 268.644 357.998 268.644 351.43Z"
      fill="#373B49"
    />
    <path
      d="M194.929 207.761L207.095 212.006C205.189 213.996 206.559 219.992 206.559 219.992C193.509 222.146 191.193 217.145 191.193 217.145C193.521 214.777 194.929 207.761 194.929 207.761Z"
      fill="#D1815B"
    />
    <path
      d="M195.052 207.621C199.062 209.057 203.072 210.506 207.095 211.942C206.92 212.093 206.597 212.433 206.397 212.988C206.198 213.554 206.248 214.046 206.285 214.272C204.691 214.008 202.039 213.365 199.286 211.539C197.294 210.216 195.924 208.73 195.052 207.621Z"
      fill="#D1815B"
    />
    <path
      d="M209.783 188.715C207.33 185.176 202.2 184.282 198.788 184.559C197.468 184.66 194.454 184.949 191.702 187.292C191.179 187.746 188.875 189.786 188.054 193.061C186.36 199.9 192.649 206.009 193.719 207.042C193.719 207.042 198.352 211.539 207.617 212.358C208.75 212.458 209.945 212.42 210.892 211.677C211.801 210.947 212.124 209.838 212.523 208.44C212.759 207.609 212.884 206.765 213.108 205.077C213.27 203.83 213.382 202.772 213.382 202.772C214.578 202.545 214.951 202.117 215.076 201.777C215.474 200.757 213.918 199.737 212.859 197.029C212.436 195.958 212.56 195.807 212.149 194.32C212.025 193.892 211.103 190.643 209.758 188.715H209.783Z"
      fill="#D1815B"
    />
    <path
      d="M201.018 201.941C200.458 202.331 199.113 200.165 196.983 200.24C196.747 200.24 195.738 200.291 195.452 200.87C195.066 201.664 196.46 202.57 196.697 204.057C196.834 204.938 196.597 206.236 194.916 208.024C194.057 207.369 192.849 206.437 191.43 205.266C188.503 202.848 187.071 201.601 186.623 200.454C185.751 198.187 186.312 195.592 186.523 194.597C186.561 194.421 186.573 194.408 187.133 192.129C187.47 190.793 187.744 189.698 187.918 188.955C188.852 185.654 190.259 184.382 191.405 183.853C192.364 183.412 192.874 183.601 194.754 182.909C196.934 182.09 196.834 181.611 198.279 181.259C199.972 180.843 200.134 181.624 203.085 181.46C205.252 181.347 205.302 180.843 206.584 181.07C208.788 181.473 210.245 183.765 210.457 184.105C210.806 184.672 210.694 184.685 211.391 185.995C212.188 187.468 212.499 187.771 212.474 188.325C212.462 188.728 212.263 189.509 210.806 190.403C210.806 190.403 209.523 190.529 209.112 190.529C208.402 190.529 207.369 190.264 206.024 188.917C204.953 190.05 204.33 191.096 203.969 191.839C203.359 193.061 203.446 193.451 202.637 195.391C202.014 196.877 201.778 197.154 201.529 197.709C201.529 197.709 201.379 198.036 201.267 198.364C200.844 199.573 201.491 201.55 200.993 201.89L201.018 201.941Z"
      fill="#62321B"
    />
    <path
      d="M199.148 202.683C199.472 202.96 199.683 203.288 199.771 203.704C199.858 204.107 199.708 204.535 199.497 204.863C199.285 205.19 198.862 205.429 198.488 205.492C198.127 205.555 197.629 205.467 197.342 205.215C196.732 204.699 196.147 204.132 195.686 203.464C195.225 202.809 194.715 202.041 194.627 201.222C194.565 200.605 194.69 200 195.051 199.484C195.387 199.005 195.923 198.665 196.495 198.577C197.442 198.438 198.301 198.993 198.799 199.773C199.223 200.441 199.621 201.121 200.02 201.802C200.231 202.154 200.182 202.646 200.057 203.011C199.933 203.401 199.609 203.691 199.26 203.867C198.911 204.044 198.426 204.044 198.065 203.905C197.666 203.754 197.429 203.464 197.218 203.099C196.881 202.545 196.558 201.991 196.221 201.436C196.296 201.55 196.358 201.663 196.433 201.776C196.333 201.625 196.234 201.474 196.097 201.348L196.383 201.625C196.321 201.562 196.259 201.512 196.184 201.461L196.533 201.65C196.533 201.65 196.408 201.6 196.346 201.575L196.732 201.676C196.732 201.676 196.632 201.663 196.583 201.663H196.994C196.994 201.663 196.894 201.663 196.844 201.676L197.243 201.55C197.243 201.55 197.18 201.575 197.143 201.6L197.479 201.386C197.479 201.386 197.367 201.474 197.317 201.524L197.591 201.235C197.591 201.235 197.529 201.323 197.492 201.373L197.678 201.021C197.641 201.084 197.616 201.159 197.591 201.222L197.691 200.832C197.678 200.907 197.666 200.983 197.666 201.071C197.666 200.932 197.666 200.794 197.666 200.655C197.666 200.769 197.691 200.882 197.728 200.995C197.691 200.857 197.654 200.731 197.604 200.592C197.703 200.907 197.878 201.197 198.04 201.474L197.828 201.134C198.177 201.688 198.588 202.179 199.061 202.633L198.774 202.356C198.899 202.469 199.011 202.57 199.136 202.671L199.148 202.683Z"
      fill="#D1815B"
    />
    <path
      d="M197.144 201.147C194.702 200.416 197.443 203.529 197.443 203.529L197.144 201.147Z"
      fill="#CA6C3F"
    />
    <path
      d="M197.863 397.616C198.747 397.881 199.706 398.12 200.727 398.321C202.408 398.662 203.977 398.838 205.359 398.913C205.745 400.727 206.144 402.554 206.53 404.367C212.993 407.416 215.782 408.209 217.102 408.297C217.389 408.31 218.36 408.322 218.983 409.028C219.705 409.834 219.63 411.056 219.618 411.207C217.999 412.177 214.923 412.555 212.632 412.693C210.141 412.857 207.999 412.781 207.974 412.781C200.789 412.995 194.837 412.089 194.463 412.026C194.712 410.401 195.024 408.713 195.385 406.987C196.095 403.612 196.941 400.475 197.851 397.616H197.863Z"
      fill="#4D5160"
    />
    <path
      d="M161.22 397.616C162.104 397.881 163.063 398.12 164.084 398.321C165.765 398.662 167.334 398.838 168.716 398.913C169.102 400.727 169.501 402.554 169.887 404.367C176.35 407.416 179.139 408.209 180.459 408.297C180.746 408.31 181.717 408.322 182.339 409.028C183.062 409.834 182.987 411.056 182.975 411.207C181.356 412.177 178.28 412.555 175.989 412.693C173.498 412.857 171.356 412.781 171.331 412.781C164.146 412.995 158.194 412.089 157.82 412.026C158.069 410.401 158.381 408.713 158.742 406.987C159.452 403.612 160.298 400.475 161.207 397.616H161.22Z"
      fill="#4D5160"
    />
    <path
      d="M206.88 302.972C206.88 302.972 201.576 321.74 186.383 354.325C171.191 386.91 170.021 401.76 170.021 401.76L159.548 401.257C159.548 401.257 160.532 362.474 167.705 346.024C174.877 329.587 176.347 284.583 176.347 284.583L206.88 302.972Z"
      fill="#115DC4"
    />
    <path
      d="M205.066 216.705C204.892 216.63 194.033 213.393 192.85 213.783C191.667 214.173 190.97 216.491 190.97 216.491L207.731 221.328C207.731 221.328 207.332 217.688 205.053 216.718L205.066 216.705Z"
      fill="#D52B1E"
    />
    <path
      d="M249.883 248.089C249.883 248.089 254.917 245.679 257.426 245.706C259.935 245.733 263.767 249.354 263.671 249.794C263.38 251.16 258.419 249.612 257.271 250.147C256.122 250.682 257.994 252.067 255.372 252.482C253.16 252.844 249.367 251.798 249.367 251.798L249.875 248.099L249.883 248.089Z"
      fill="#D1815B"
    />
    <path
      d="M254.866 250.27C254.866 250.27 256.488 249.944 258.059 249.641C259.204 249.411 260.3 248.802 260.763 248.743C261.872 248.598 261.234 250.457 258.879 251.56C256.887 252.49 254.472 252.605 253.712 252.534C252.952 252.463 254.866 250.27 254.866 250.27Z"
      fill="#D1815B"
    />
    <path
      d="M251.874 248.962C252.132 246.597 251.894 246.273 251.894 246.273C251.894 246.273 230.28 239.494 228.275 238.777C226.278 238.05 201.841 220.36 201.841 220.36L182.289 230.252C182.289 230.252 219.091 248.501 224.197 250.247C232.634 253.115 250.652 252.093 250.652 252.093C250.652 252.093 251.645 250.831 251.849 248.973L251.874 248.962Z"
      fill="#D52B1E"
    />
    <path
      d="M175.585 289.804C177.428 298.294 215.63 274.812 215.12 269.635C215.058 269.068 215.184 265.318 215.122 264.751C214.412 257.534 213.739 250.468 213.69 245.858C213.652 241.865 213.104 237.771 212.382 234.056C211.71 230.63 210.9 227.519 210.178 225.088C209.68 223.375 208.733 221.876 207.501 220.692C206.617 219.848 205.583 219.18 204.437 218.714C204.126 218.576 203.815 218.475 203.491 218.374C198.871 217.014 192.47 215.339 190.739 215.855C186.045 217.253 182.558 225.617 180.08 236.273C175.46 256.224 174.389 284.237 175.597 289.779L175.585 289.804Z"
      fill="#F15C5C"
    />
    <path
      d="M184.883 307.438C182.442 301.893 178.699 296.135 176.091 291.279C174.099 287.569 172.115 284.149 176.196 263.29C189.898 266.29 201.805 267.741 215.647 268.155C216.507 273.769 215.94 286.331 214.29 297.104C213.96 308.822 212.943 328.243 209.89 350.16C204.921 385.831 206.602 400.983 206.602 400.983L194.698 401.386C194.698 401.386 187.587 365.703 189.629 347.842C190.732 338.203 187.808 321.122 184.883 307.438Z"
      fill="#5196E5"
    />
    <g clipPath="url(#clip0_27088_67938)">
      <path
        d="M267.999 215.225L277.231 223.072L259.732 244.136L250.5 236.289L267.999 215.225Z"
        fill="#676C7D"
      />
      <mask
        id="mask1_27088_67938"
        mask-type="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="250"
        y="131"
        width="106"
        height="102"
      >
        <path
          d="M250.397 182.097C250.397 154.109 273.085 131.421 301.073 131.421L305.127 131.421C333.115 131.421 355.804 154.109 355.804 182.097C355.804 210.085 333.115 232.774 305.127 232.774L301.073 232.774C273.085 232.774 250.397 210.085 250.397 182.097Z"
          fill="#E3E5EE"
        />
      </mask>
      <g mask="url(#mask1_27088_67938)">
        <path
          d="M118.031 140.555C116.233 135.334 119.008 129.642 124.229 127.844L695.194 -68.8138C700.415 -70.6124 706.106 -67.8373 707.905 -62.6155L773.43 127.627C775.229 132.849 772.454 138.54 767.232 140.339L196.268 336.996C191.046 338.795 185.355 336.02 183.557 330.798L118.031 140.555Z"
          fill="#CFD2E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M507.979 69.0839C454.184 98.9994 416.713 136.237 382.115 178.766C351.471 216.435 303.854 241.696 257.826 257.711C219.762 270.955 182.284 278.085 154.791 281.077C148.05 281.811 143.354 274.835 146.321 268.738C147.718 265.867 150.546 263.982 153.728 263.719C177.995 261.715 215.075 255.364 252.355 242.393C291.964 228.61 331.058 207.663 356.411 176.499C391.808 132.987 432.622 91.6513 493.627 57.7265C552.48 24.9982 628.009 0.312675 731.415 -13.8662C737.641 -14.72 742.587 -8.75273 740.633 -2.77947C739.602 0.371838 736.822 2.64568 733.535 3.07401C630.765 16.4625 560.493 39.8811 507.979 69.0839Z"
          fill="#80B6F0"
        />
        <path
          d="M269.108 223.304C246.806 233.924 180.485 241.243 169.768 238.603C148.435 233.349 216.855 142.39 256.103 128.871C279.955 120.656 333.657 145.646 334.513 152.614C335.923 164.082 285.879 215.319 269.108 223.304Z"
          fill="#9AD49A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M259.172 314.32C262.3 314.991 265.56 314.126 267.942 311.992L388.858 203.684C390.05 202.616 391.698 202.213 393.249 202.61C396.966 203.561 398.119 208.274 395.261 210.834L269.792 323.22C267.409 325.354 264.15 326.22 261.022 325.549L163.714 304.672C159.557 303.781 158.093 298.602 161.167 295.666C162.435 294.454 164.22 293.95 165.935 294.317L259.172 314.32Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M265.662 101.233C268.06 99.6016 271.047 99.0912 273.85 99.8338L433.682 142.186C437.903 143.305 439.175 148.677 435.903 151.569C434.533 152.78 432.648 153.226 430.881 152.758L273.184 110.971C270.381 110.229 267.394 110.739 264.997 112.37L89.9116 231.509C88.5896 232.408 86.8847 232.523 85.4541 231.809C82.4354 230.302 82.1527 226.104 84.9421 224.206L265.662 101.233Z"
          fill="white"
        />
        <path
          d="M403.201 224.004C396.106 225.162 349.011 265.865 345.841 268.49C344.47 269.626 342.664 273.5 341.055 277.532C338.809 283.159 343.691 286.132 350.625 283.743L464.932 244.372C470.284 242.529 472.9 236.692 468.755 235.806C447.842 231.334 408.381 223.159 403.201 224.004Z"
          fill="#ABAFBF"
        />
      </g>
      <path
        d="M337.387 141.181C359.728 160.17 362.62 193.882 343.846 216.48C325.073 239.077 291.745 242.002 269.404 223.013C247.063 204.024 244.172 170.314 262.945 147.716C281.718 125.118 315.047 122.193 337.387 141.181ZM274.781 216.541C293.588 232.526 321.645 230.063 337.448 211.041C353.25 192.019 350.817 163.639 332.01 147.654C313.203 131.669 285.147 134.133 269.344 153.155C253.541 172.177 255.975 200.556 274.781 216.541Z"
        fill="#676C7D"
      />
      <path
        opacity="0.5"
        d="M299.55 137.277C275.078 139.425 256.96 161.233 259.084 185.987C261.208 210.74 282.768 229.066 307.241 226.919C331.713 224.771 349.831 202.962 347.708 178.208C345.585 153.453 324.024 135.129 299.551 137.276L299.55 137.277Z"
        fill="#D3E6FA"
      />
      <path
        opacity="0.5"
        d="M347.651 177.632C347.67 177.824 347.691 178.015 347.708 178.208C349.831 202.962 331.714 224.77 307.241 226.919C282.769 229.067 261.208 210.741 259.084 185.987C259.068 185.793 259.057 185.602 259.042 185.408L347.651 177.632Z"
        fill="#C5DEF9"
      />
      <path
        opacity="0.5"
        d="M286.528 147.594C286.027 152.259 294.792 157.047 306.103 158.291C317.415 159.535 326.993 156.761 327.493 152.098C327.994 147.434 319.23 142.646 307.918 141.402C296.606 140.159 287.029 142.932 286.527 147.595L286.528 147.594Z"
        fill="white"
      />
      <path
        d="M266.188 233.837L259.419 228.083C257.153 226.157 253.768 226.455 251.864 228.746L205.148 284.979C203.244 287.272 203.537 290.696 205.804 292.623L212.572 298.376C214.838 300.302 218.224 300.005 220.129 297.712L266.845 241.479C268.749 239.187 268.455 235.763 266.189 233.837L266.188 233.837Z"
        fill="#373B49"
      />
      <path
        d="M258.305 227.36L204.906 291.637C203.504 289.67 203.534 286.922 205.147 284.98L251.863 228.747C253.476 226.805 256.147 226.301 258.305 227.36Z"
        fill="#4D5160"
      />
      <path
        d="M211.158 287.558C213.426 289.486 216.808 289.188 218.713 286.895L264.197 232.145L266.188 233.837C268.456 235.764 268.75 239.186 266.844 241.48L220.128 297.713C218.222 300.007 214.84 300.303 212.572 298.376L205.804 292.623C203.536 290.695 203.242 287.273 205.147 284.98L206.38 283.497L211.158 287.558Z"
        fill="#262A37"
      />
    </g>
    <path
      d="M214.361 263.316C214.361 263.316 220.049 262.999 220.965 263.216C221.875 263.443 223.04 262.504 223.277 262.398C224.133 262.006 223.648 263.342 223.183 263.662C222.641 264.039 221.853 264.56 223.071 265.077C223.304 265.174 225.168 266.243 225.048 267.33C224.928 268.416 223.527 271.547 221.058 271.256C218.588 270.966 214.273 267.27 213.863 267.154C210.429 266.236 214.351 263.31 214.351 263.31L214.361 263.316Z"
      fill="#D1815B"
    />
    <path
      d="M214.833 262.591C214.833 262.591 193.065 254.032 191.817 252.117C189.84 249.057 203.818 233.694 203.818 233.694C203.818 233.694 208.49 225.644 203.818 221.35C197.778 215.796 188.647 217.102 185.257 225.004C181.076 234.7 172.034 254.092 176.325 260.504C181.868 268.773 212.165 268.55 212.165 268.55C212.165 268.55 213.446 268.078 214.342 266.316C215.135 264.755 214.826 262.602 214.826 262.602L214.833 262.591Z"
      fill="#E63F39"
    />
    <defs>
      <clipPath id="clip0_27088_67938">
        <rect
          width="106.176"
          height="200.621"
          fill="white"
          transform="matrix(-0.761951 -0.647635 -0.639016 0.769193 377.838 175.564)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default PolicyZipCode;
